import DataDisplayList from './DataDisplayList'
export default DataDisplayList
